// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"aa511f75","78":"e0adf085","557":"ba2e1acf","747":"ef3e60de"}[chunkId] + ".chunk.js";
};